// src/hooks/useApi.js
import {axiosInstance} from "../api/axiosInstance";
import {useAuth} from "../providers/authentication.provider";

export const useApi = () => axiosInstance;
// export const useApi = () => {
//     const { accessToken } = useAuth();
//
//     axiosInstance.interceptors.request.use((config) => {
//         if (accessToken) {
//             config.headers["x-authenticated-user"] = `Bearer ${accessToken}`;
//         }
//         return config;
//     });
//
//     return axiosInstance;
// };
